module.exports = __webpack_public_path__ + "img/shortage-modal-bg.f760c5ca.png";